<template>
  <div>
    <qr-code :titleText="title"></qr-code>
  </div>
</template>

<script>
/* global PUBLIC_EMPTY_TITLE */

import QrCode from '@/components/QrCode.vue';

export default {
  name: 'HelpQrcode',
  components: {
    QrCode,
  },
  data() {
    return {
      title: PUBLIC_EMPTY_TITLE === '1' ? '意见反馈' : '帮助和反馈',
    };
  },
};
</script>
